import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from '@mui/material';
import React, { useState } from 'react';
import CustomButton from '../../../../../../../../../../lib/designSystem/Button';
import { loggerDev } from '../../../../../../../../../../lib/functions/utils';
import { rescheduleCollectionManagement } from '../../../../../../../../../../lib/api/collections';
import { showAlert } from '../../../../../../../../../../lib/functions/utils';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../../lib/designSystem/CircularProgress';

interface propsType {
  dueDate: string;
  setDueDate: any;
  open: boolean;
  setOpen: any;
  openEditManagementId: number;
  setConfirmDialogTitle: any;
  setConfirmDialogDescription: any;
  setConfirmAction: any;
  setButtonColor: any;
  setConfirmDialogOpen: any;
}

const RescheduleManagement: React.FC<propsType> = (props: propsType) => {
  const {
    dueDate,
    setDueDate,
    open,
    setOpen,
    openEditManagementId,
    setConfirmDialogTitle,
    setConfirmDialogDescription,
    setConfirmAction,
    setButtonColor,
    setConfirmDialogOpen,
  } = props;

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const handleConfirmRescheduleDialog = () => {
    setConfirmDialogTitle('Reprogramar gestión ' + `#${openEditManagementId}`);
    setConfirmDialogDescription(
      '¿Estás seguro de que deseas reprogramar la gestión?',
    );
    setConfirmAction(() => async () => await handleRescheduleFinal());
    setButtonColor('primary');
    setConfirmDialogOpen(true);
  };

  const handleRescheduleFinal = async () => {
    if (!openEditManagementId)
      return alert('No se ha seleccionado ninguna gestión');
    setConfirmDialogOpen(false);
    setLoading(true);
    try {
      await rescheduleCollectionManagement(dispatch, openEditManagementId, {
        newDueDate: dueDate,
      });
      showAlert(dispatch, 'success', 'Gestión reprogramada');
      window.location.reload();
    } catch (error) {
      loggerDev(error);
      showAlert(dispatch, 'error', 'Error al reprogramar la gestión');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Reprogramar gestión</DialogTitle>
      {loading ? (
        <div style={{ minHeight: 200 }}>
          <CenteredCircularProgress type="dialog" />
        </div>
      ) : (
        <>
          <DialogContent>
            <TextField
              style={{ marginTop: 8 }}
              id="outlined-basic-two"
              label="Nueva fecha de vencimiento"
              variant="outlined"
              type="date"
              value={dueDate}
              fullWidth
              onChange={(e) => {
                setDueDate(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <CustomButton color="secondary" onClick={() => setOpen(false)}>
              Cancelar
            </CustomButton>
            <CustomButton onClick={() => handleConfirmRescheduleDialog()}>
              Avanzar
            </CustomButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default RescheduleManagement;
